"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientsService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const integration_service_1 = require("./integration.service");
let ClientsService = class ClientsService {
    constructor(_http, _talk, _integration) {
        this._http = _http;
        this._talk = _talk;
        this._integration = _integration;
        //initializations
        this.clientURL = "/client";
    }
    get() {
        return JSON.parse(JSON.stringify(this.clients));
    }
    pull() {
        return this._http.get(this.clientURL)
            .toPromise()
            .then(response => this.set(response.json()))
            .catch(this._talk.handle);
    }
    pullAll() {
        return this._http.get(`${this.clientURL}?getAll=true`)
            .toPromise()
            .then(res => res.json())
            .catch(this._talk.handle);
    }
    set(clients) {
        // set client and set default domains if no found
        this.clients = clients.filter(client => {
            if (!client.domains)
                client.domains = '';
            return client;
        });
        return this.clients;
    }
    getClientAssociatedDomains() {
        var payload = [];
        for (let c in this.clients) {
            if (this.clients[c].domains && this.clients[c].domains != '') {
                let domainList = this.clients[c].domains.split(', ');
                for (let d in domainList) {
                    payload.push(domainList[d]);
                }
            }
        }
        return payload;
    }
    gptInstantLoadHelp() {
        this._talk.broadcast("GPT Instant Load leverages the googletag.pubads().disableInitialLoad() call to disable GPT from sending out ad requests immediately. This call informs GPT to wait until the first googletag.pubads().refresh() occurs. GPT Instant Load triggers the refresh() call when all requested bids are back, or when the timeout is hit, whichever happens faster.");
    }
    enableServicesHelp() {
        this._talk.broadcast("This enables all GPT services that have been defined for ad slots on the page. If you have any ad slots that Biddr360 will not be bidding into, those ad slots should be defined on the page and enable services should not be included in your Biddr360 integration. Enable Services should not be included in GPT Instant Load integration types.");
    }
    internalRefreshHelp() {
        this._talk.broadcast("Allows publisher the option of removing all gpt functions with the exception of setting targeting from the bRealtime script. In this integration type publishers must handle calls to pubads().disableInitialLoad() and pubads().refresh() on the page. Publisher may also be required to add a timeout before calling and pubads().refresh().");
    }
    pubCommonIdHelp() {
        this._talk.broadcast("Allows publisher to use the Publisher Common ID Module. This module stores a unique user id in the first party domain and passes it in the request.");
    }
    holisticResequencerHelp() {
        this._talk.broadcast("The Holistic Resequencer feature allows for your Demand Partner sequence (the order in which bidders are called) to be randomized each time your header bidding script runs. This feature provides the ability to run a holistic header bidding auction in which there are no biases towards any Demand Partners. It can be enabled across your entire def file only.");
    }
    dynamicAdUnitTargetingHelp() {
        this._talk.broadcast("The Dynamic Ad Unit Targeting feature will detect all ad units actually defined on a page and will request bids only for ad units that are present.");
    }
    dynamicAdUnitTargetingFallbackHelp() {
        this._talk.broadcast("The Dynamic Ad Unit Targeting Fallback adds error handling for dynamic ad unit targeting.  If no ad units are detected, bids will be requested for all ad units in the def file.  Caution: Do Not Use this feature on def files with more than 15 ad units.");
    }
    targetAdUnitDivIDHelp() {
        this._talk.broadcast("Selecting the Only Target Ad Unit Div Id or the Only Target Ad Unit Code options will set your integration to target ad units by either the div (ad slot div id) or the code (ad slot name) only when using Dynamic Ad Unit Targeting. This is instead of targeting both which is the default and will be used if neither option is chosen.");
    }
    targetAdUnitCodeHelp() {
        this._talk.broadcast("Selecting the Only Target Ad Unit Div Id or the Only Target Ad Unit Code options will set your integration to target ad units by either the div (ad slot div id) or the code (ad slot name) only when using Dynamic Ad Unit Targeting. This is instead of targeting both which is the default and will be used if neither option is chosen.");
    }
    instantAuctionHelp() {
        this._talk.broadcast("Enabling Instant Auction means that as soon as the Biddr script is loaded, it will immediately try and start an auction instead of waiting for the typical enableServices() call to start running the code. This should be used sparingly and careful attention needs to be paid so that duplicate requests are not sent out for the same Ad Units.");
    }
    waitForSlotDefinitionHelp() {
        this._talk.broadcast("Selecting Wait For Slot Definition stops our Bidder file from starting to load when it is first referenced on a page. Instead, it waits for a gpt.defineSlot() call to be made and then proceeds with the rest of the functionality inside the Bidder file.");
    }
    guaranteedRefreshHelp() {
        this._talk.broadcast("Guaranteed Refresh allows you to guarantee a refresh ads call from the Bidder file no matter what issues might occur elsewhere in the Bidder script.");
    }
    immediateFirePixelHelp() {
        this._talk.broadcast("Immediately firing the pixel on each page load prevents any interruptions where check.js is not firing on the page when it's completed loading.");
    }
    refreshOptionHelp() {
        this._talk.broadcast("Toggle between the two types of targeting Ad Units for refresh. Default is Slot Ad Unit Path. Checked is Slot Element ID");
    }
    newUnitGenerationHelp() {
        this._talk.broadcast("Used for dynamically creating adUnits after the first auction has occurred. This is especially useful for infinite scroll ad units that need to be added to a new auction rather than refreshed.");
    }
    enforceGDPRDemandPartnersHelp() {
        this._talk.broadcast("When checked, this will ensure that when the auction is held on a page that has a GDPR Consent Management Platform (CMP) all non-GDPR-compliant demand partners will be removed from the auction.");
    }
    enforceCCPADemandPartnersHelp() {
        this._talk.broadcast("When checked, this will ensure that when the auction is held on a page that has a CCPA Consent Management Platform (CMP) all non-CCPA-compliant demand partners will be removed from the auction.");
    }
    enforceTCF2DemandPartnersHelp() {
        this._talk.broadcast("When checked, this will ensure that when the auction is held on a page that has a GDPR TCF2 Consent Management Platform (CMP) all non-GDPR-TCF2-compliant demand partners will be removed from the auction.");
    }
    castTAsIntegerHelp() {
        this._talk.broadcast("When checked, this will ensure that the 't' parameter that is passed to bid requests is cast as an integer as opposed to potentially being a float.  OpenRTB specs dictate that the 't' parameter must always be an integer.");
    }
};
exports.ClientsService = ClientsService;
exports.ClientsService = ClientsService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        integration_service_1.IntegrationService])
], ClientsService);
//# sourceMappingURL=clients.service.js.map